import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Container, Grid, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { getTranslation } from '../../i18n';

const Footer = () => {
  const { language } = useSelector((state) => state.ui);
  const translations = getTranslation(language);

  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 4, 
        backgroundColor: '#0E58A0',
        color: 'rgba(255,255,255,0.8)',
        mt: 'auto', // Push footer to the bottom if content is short
        width: '100%',
        position: 'static', // Changed from default to ensure footer stays in document flow
        bottom: 0,
        zIndex: 10
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
              SkyRadar
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>
              Enterprise-grade lightning detection and monitoring solutions for businesses and organizations worldwide.
            </Typography>
            <Typography variant="body2">
              © {new Date().getFullYear()} SkyRadar. All rights reserved
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link to="/map" style={{ color: 'inherit', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { color: 'white' } }}>
                  Map
                </Typography>
              </Link>
              <Link to="/about" style={{ color: 'inherit', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { color: 'white' } }}>
                  About
                </Typography>
              </Link>
              <Link to="/contact" style={{ color: 'inherit', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { color: 'white' } }}>
                  Contact
                </Typography>
              </Link>
              <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { color: 'white' } }}>
                  Privacy Policy
                </Typography>
              </Link>
              <Link to="/terms" style={{ color: 'inherit', textDecoration: 'none' }}>
                <Typography variant="body2" sx={{ '&:hover': { color: 'white' } }}>
                  Terms of Service
                </Typography>
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" sx={{ color: 'white', mb: 2, fontWeight: 600 }}>
              Contact Us
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              Email: info@skyradar.com
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default Footer;
